<div class="sidebar-main">
    <div class="history" [ngClass]="{ 'collapsed': !showSidebar }">
        <div class="top">
            <!-- Dynamic Menu-->
            <form [formGroup]="menuForm">
                <div class="category-outer-wrapper">
                    <div class="sidediv" *ngFor="let item of defaultMenuArr; let i = index">


                        <div class="category-section"
                            *ngIf="item.menu_metadata.menu_type === 'default' && item.menu_metadata?.input_type !== 'region' && item.menu_metadata?.input_type !== 'market' && item.menu_metadata?.input_type !== 'product'">
                            <!-- <span class="category-txt">{{ item.menu_label }}</span> -->
                            <label class="lbl-category">{{ item.menu_label }}</label>
                            <mat-form-field class="mb-cat cust-select">
                                <mat-select formControlName="categoryName" (selectionChange)="changeCategory($event)">
                                    <mat-option *ngFor="let child of item.children" [value]="child.menu_code">
                                        {{ child.menu_label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="category-section"
                            *ngIf="showRegion && item?.menu_metadata?.menu_type === 'default' && productData.length && item?.menu_metadata?.input_type === 'product'">
                            <div id="market-loader" class="loader"></div>
                            <!-- <span class="category-txt">{{ item.menu_label }}</span> -->
                            <label class="lbl-category">{{ item.menu_label }}</label>
                            <mat-form-field class="mb-cat cust-select">
                                <mat-select (openedChange)="productOpenedChange($event)" placeholder="Select"
                                    formControlName="productSelectFormControl" multiple panelClass="my-target-panel"
                                    [(ngModel)]="productSelectedValues">
                                    <mat-select-trigger>
                                        <!-- {{menuForm.get('productSelectFormControl')?.value ? menuForm.get('productSelectFormControl')?.value[0] : ''}} -->
                                        <span
                                            *ngIf="menuForm.get('productSelectFormControl')?.value?.length === productData.length"
                                            class="additional-selection">
                                            All
                                        </span>
                                        <span *ngIf="menuForm.get('productSelectFormControl')?.value?.length === 1"
                                            class="additional-selection">
                                            {{getProductNameByCode(menuForm.get('productSelectFormControl')?.value)}}
                                        </span>
                                        <span
                                            *ngIf="menuForm.get('productSelectFormControl')?.value?.length > 1 && menuForm.get('productSelectFormControl')?.value?.length !== productData.length"
                                            class="additional-selection">
                                            {{getProductNameByCode(menuForm.get('productSelectFormControl')?.value) ?
                                            getProductNameByCode(menuForm.get('productSelectFormControl')?.value[0]) :
                                            ''}}
                                            (+{{getProductNameByCode(menuForm.get('productSelectFormControl')?.value)?.length
                                            - 1}}
                                            {{getProductNameByCode(menuForm.get('productSelectFormControl')?.value)?.length
                                            === 2 ? 'product' : 'products'}})
                                        </span>
                                    </mat-select-trigger>
                                    <div class="select-container">
                                        <mat-optgroup *ngIf="item?.menu_metadata?.search">
                                            <mat-form-field style="width:100%;" class="search-input">
                                                <input #searchProduct autocomplete="off" placeholder="Search"
                                                    aria-label="Search" matInput
                                                    formControlName="productSearchTextboxControl">
                                                <button [disableRipple]="true" *ngIf="searchProduct?.value" matSuffix
                                                    mat-icon-button aria-label="Clear"
                                                    (click)="productClearSearch($event)">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </mat-optgroup>
                                        <mat-optgroup *ngIf="(productFilteredOptions | async)?.length == 0">
                                            <div>No results found!</div>
                                        </mat-optgroup>
                                        <app-select-check-all
                                            *ngIf="!menuForm.get('productSearchTextboxControl')?.value"
                                            [model]="menuForm.get('productSelectFormControl')" [values]="productData"
                                            (allCheckboxEvent)="addAll($event)">
                                        </app-select-check-all>
                                        <mat-option (onSelectionChange)="productSelectionChange($event)"
                                            *ngFor="let option of productFilteredOptions | async" [value]="option.code">
                                            {{option.label}}
                                        </mat-option>
                                    </div>
                                </mat-select>
                            </mat-form-field>

                        </div>

                    </div>
                </div>
                <div class="sidediv" *ngFor="let item of menuArr;let i=index">
                    <div class="message-box" (click)="onParentMenuClick(item, i)" [title]="item.menu_label"
                        [ngClass]="{ 'highlight': selectedMenu === item.menu_code || selectedParentMenu === item.menu_code}">
                        <div (click)="onParentMenuToggle(item, i)" class="focus-block"
                            [ngClass]="showChatFocus ? 'focus-bold': ''">
                            <img [src]="'../../../assets/icons/' + item.menu_label.split(' ').join('-') + '.svg'" alt=""
                                width="16" height="16" />
                            <span *ngIf="!item.children.length">{{item.menu_label}}</span>
                            <span *ngIf="item.children.length">{{item.menu_label}}</span>
                            <span class="plusicon"
                                *ngIf="!dynamicMenuOpenClose[i] && (item.children.length || item.menu_code === 'History')">+</span>
                            <span class="plusicon"
                                *ngIf="dynamicMenuOpenClose[i] && (item.children.length || item.menu_code === 'History')">-</span>
                        </div>
                    </div>
                    <div class="history-list dynamic-history"
                        *ngIf="dynamicMenuOpenClose[i] && !item.children.length && item.menu_code === 'History'">
                        <mat-expansion-panel class="mat-elevation-z0">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <img src="../../../assets/icons/icon-history-time.svg" alt="" width="14"
                                        height="14" /> TODAY
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-nav-list>
                                <div *ngFor="let item of todayHistory">
                                    <li class="history-item">
                                        <div class="icon-history-time-list"><img
                                                src="../../../assets/icons/icon-history-time-list.svg" alt="" width="14"
                                                height="14" /></div>
                                        <div class="block-1">
                                            <ng-container *ngIf="!item.isEditing; else editingMode">
                                                <div class="history-item-1"
                                                    [ngClass]="{ 'active-history': selectedHistoryId === item.chat_session_id }"
                                                    (click)="confirmAndHandleDetails(item.chat_session_id, item.chat_type)"
                                                    title="{{ item.primary_market ? item.primary_market + ' - ' : '' }}{{ item.chat_name }}">
                                                    {{
                                                    item.primary_market ?
                                                    (item.primary_market.split(',').slice(0, 2).join(', ')) + ' - ' +
                                                    item.chat_name :
                                                    item.chat_name
                                                    }}
                                                </div>
                                            </ng-container>
                                            <ng-template #editingMode>
                                                <input type="text" [(ngModel)]="item.newChatName"
                                                    [value]="item.chat_name" [ngModelOptions]="{standalone: true}"
                                                    (blur)="onInputChange($event, item)" #chatNameInput />
                                            </ng-template>

                                        </div>
                                        <div class="block-2">
                                            <button mat-button [matMenuTriggerFor]="menu" class="dots">...</button>
                                            <mat-menu #menu="matMenu" class="left-menu-edit">
                                                <button (click)="toggleEdit(item)" class="option"
                                                    mat-menu-item>Rename</button>
                                                <button (click)="delete(item.chat_session_id)" class="option"
                                                    mat-menu-item>Delete</button>
                                            </mat-menu>
                                        </div>
                                    </li>
                                </div>
                            </mat-nav-list>
                        </mat-expansion-panel>
                        <mat-expansion-panel class="mat-elevation-z0">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <img src="../../../assets/icons/icon-history-time.svg" alt="" width="14"
                                        height="14" /> CURRENT WEEK
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-nav-list>
                                <div *ngFor="let item of yesterdayHistory">
                                    <li class="history-item">
                                        <div class="icon-history-time-list"><img
                                                src="../../../assets/icons/icon-history-time-list.svg" alt="" width="14"
                                                height="14" /></div>
                                        <div class="block-1">
                                            <ng-container *ngIf="!item.isEditing; else editingMode">
                                                <div class="history-item-1"
                                                    [ngClass]="{ 'active-history': selectedHistoryId === item.chat_session_id }"
                                                    (click)="confirmAndHandleDetails(item.chat_session_id, item.chat_type)"
                                                    title="{{ item.primary_market ? item.primary_market + ' - ' : '' }}{{ item.chat_name }}">
                                                    {{
                                                    item.primary_market ?
                                                    (item.primary_market.split(',').slice(0, 2).join(', ')) + ' - ' +
                                                    item.chat_name :
                                                    item.chat_name
                                                    }}
                                                </div>
                                            </ng-container>
                                            <ng-template #editingMode>
                                                <input type="text" [(ngModel)]="item.newChatName"
                                                    [value]="item.chat_name" [ngModelOptions]="{standalone: true}"
                                                    (blur)="onInputChange($event, item)" />
                                            </ng-template>

                                        </div>
                                        <div class="block-2">
                                            <button mat-button [matMenuTriggerFor]="menu" class="dots">...</button>
                                            <mat-menu #menu="matMenu" class="left-menu-edit">
                                                <button (click)="toggleEdit(item)" class="option"
                                                    mat-menu-item>Rename</button>
                                                <button (click)="delete(item.chat_session_id)" class="option"
                                                    mat-menu-item>Delete</button>
                                            </mat-menu>
                                        </div>
                                    </li>
                                </div>
                            </mat-nav-list>
                        </mat-expansion-panel>
                        <mat-expansion-panel class="mat-elevation-z0">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <img src="../../../assets/icons/icon-history-time.svg" alt="" width="14"
                                        height="14" /> LAST WEEK
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-nav-list>
                                <div *ngFor="let item of weekHistory">
                                    <li class="history-item">
                                        <div class="icon-history-time-list"><img
                                                src="../../../assets/icons/icon-history-time-list.svg" alt="" width="14"
                                                height="14" /></div>
                                        <div class="block-1">
                                            <ng-container *ngIf="!item.isEditing; else editingMode">
                                                <div class="history-item-1"
                                                    [ngClass]="{ 'active-history': selectedHistoryId === item.chat_session_id }"
                                                    (click)="confirmAndHandleDetails(item.chat_session_id, item.chat_type)"
                                                    title="{{ item.primary_market ? item.primary_market + ' - ' : '' }}{{ item.chat_name }}">
                                                    {{
                                                    item.primary_market ?
                                                    (item.primary_market.split(',').slice(0, 2).join(', ')) + ' - ' +
                                                    item.chat_name :
                                                    item.chat_name
                                                    }}
                                                </div>
                                            </ng-container>
                                            <ng-template #editingMode>
                                                <input type="text" [(ngModel)]="item.newChatName"
                                                    [value]="item.chat_name" [ngModelOptions]="{standalone: true}"
                                                    (blur)="onInputChange($event, item)" />
                                            </ng-template>

                                        </div>
                                        <div class="block-2">
                                            <button mat-button [matMenuTriggerFor]="menu" class="dots">...</button>
                                            <mat-menu #menu="matMenu" class="left-menu-edit">
                                                <button (click)="toggleEdit(item)" class="option"
                                                    mat-menu-item>Rename</button>
                                                <button (click)="delete(item.chat_session_id)" class="option"
                                                    mat-menu-item>Delete</button>
                                            </mat-menu>
                                        </div>
                                    </li>
                                </div>
                            </mat-nav-list>
                        </mat-expansion-panel>
                        <mat-expansion-panel class="mat-elevation-z0">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <img src="../../../assets/icons/icon-history-time.svg" alt="" width="14"
                                        height="14" /> LAST MONTH
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-nav-list>
                                <div *ngFor="let item of monthHistory">
                                    <li class="history-item">
                                        <div class="icon-history-time-list"><img
                                                src="../../../assets/icons/icon-history-time-list.svg" alt="" width="14"
                                                height="14" /></div>
                                        <div class="block-1">
                                            <ng-container *ngIf="!item.isEditing; else editingMode">
                                                <div class="history-item-1"
                                                    [ngClass]="{ 'active-history': selectedHistoryId === item.chat_session_id }"
                                                    (click)="confirmAndHandleDetails(item.chat_session_id, item.chat_type)"
                                                    title="{{ item.primary_market ? item.primary_market + ' - ' : '' }}{{ item.chat_name }}">
                                                    {{
                                                    item.primary_market ?
                                                    (item.primary_market.split(',').slice(0, 2).join(', ')) + ' - ' +
                                                    item.chat_name :
                                                    item.chat_name
                                                    }}
                                                </div>
                                            </ng-container>
                                            <ng-template #editingMode>
                                                <input type="text" [(ngModel)]="item.newChatName"
                                                    [value]="item.chat_name" [ngModelOptions]="{standalone: true}"
                                                    (blur)="onInputChange($event, item)" />
                                            </ng-template>
                                        </div>
                                        <div class="block-2">
                                            <button mat-button [matMenuTriggerFor]="menu" class="dots">...</button>
                                            <mat-menu #menu="matMenu" class="left-menu-edit">
                                                <button (click)="toggleEdit(item)" class="option"
                                                    mat-menu-item>Rename</button>
                                                <button (click)="delete(item.chat_session_id)" class="option"
                                                    mat-menu-item>Delete</button>
                                            </mat-menu>
                                        </div>
                                    </li>
                                </div>
                            </mat-nav-list>
                        </mat-expansion-panel>
                    </div>

                    <div class="list-table" *ngIf="dynamicMenuOpenClose[i] && item.children.length">
                        <ul class="abiochat-list">
                            <li class="list-item" *ngFor="let child of item.children"
                                (click)="newAbioChat(child.menu_code, item.menu_code)"
                                [ngClass]="{ 'highlight': selectedMenu === child.menu_code}">
                                {{child.menu_label}}</li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
        <div class="mobile-ios-download" #mobileIosDownload *ngIf="showMobileIosDownload" [ngClass]="{ 'expanded': isMobileIosExpanded }">
            <div class="mobile-ios-header" (click)="toggleMobileIosDownload($event)">
                <span class="apple-icon-box">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="#ffffff" aria-hidden="true">
                        <path d="M16.37 12.64c-.02-2.2 1.8-3.26 1.88-3.31-1.02-1.5-2.62-1.7-3.19-1.73-1.36-.14-2.65.8-3.34.8-.69 0-1.75-.78-2.88-.76-1.48.02-2.85.86-3.61 2.19-1.54 2.67-.39 6.62 1.1 8.79.73 1.06 1.6 2.25 2.74 2.21 1.1-.04 1.52-.71 2.85-.71 1.33 0 1.71.71 2.88.69 1.19-.02 1.94-1.08 2.66-2.15.84-1.23 1.19-2.42 1.21-2.48-.03-.01-2.3-.88-2.3-3.54zM14.2 6.1c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.69-.92 2.68.97.07 1.96-.49 2.56-1.23z"/>
                    </svg>
                </span>
                <div class="mobile-ios-title-block">
                    <span class="mobile-ios-title" title="{{ mobileIosTitle }}">{{ mobileIosTitle }}</span>
                    <span class="mobile-ios-label" *ngIf="isMobileIosExpanded">iOS</span>
                </div>
                <mat-icon class="mobile-ios-chevron">{{ isMobileIosExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="mobile-ios-content" *ngIf="isMobileIosExpanded">
                <ng-container *ngIf="!isMobileOrTabletDevice; else mobileStoreOnly">
                    <p class="mobile-ios-desc">Scan below to install the enterprise AI Advisor app directly on your device.</p>
                    <div class="mobile-ios-qr-wrapper">
                        <img class="mobile-ios-qr" src="../../../assets/images/AI_Advisor_QRcode.png"
                            alt="AI Advisor iOS app QR code" title="Open AI Advisor iOS app details"
                            (click)="downloadiOS()" />
                        <div class="mobile-ios-qr-info">
                            <span class="qr-install-label">Instant iOS install</span>
                            <button type="button" class="store-link-btn" (click)="openAppStore()">
                                <mat-icon class="store-link-icon">open_in_new</mat-icon>
                                App Store Link
                            </button>
                        </div>
                    </div>
                </ng-container>
                <ng-template #mobileStoreOnly>
                    <span class="qr-install-label standalone-label">Instant iOS install</span>
                    <button type="button" class="store-link-btn full-width" (click)="openAppStore()">
                        <mat-icon class="store-link-icon">open_in_new</mat-icon>
                        App Store Link
                    </button>
                </ng-template>
            </div>
        </div>
    </div>
</div>